<template>
  <!-- 主要显示的内容 -->
  <yxtf-tooltip placement="top" open-filter class="ellipsis">
    <div slot="content" :style="{ 'max-width': rankWidth + 'px' }">
      <content-name :code="code" :name="name" />
    </div>
    <content-name
      class="lh22 text-26 block"
      :code="code"
      :name="name"
    />
  </yxtf-tooltip>
</template>
<script>
import contentName from './contentName.vue';

export default {
  components: {
    contentName
  },
  props: {
    // 类型
    code: {
      type: String,
      default: ''
    },
    // 名称
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rankWidth: 0
    };
  },
  mounted() {
    this.rankWidth = this.$parent.$el.clientWidth * 0.7;
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
